/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { isString, isBlob, isFormData } from "./request-guards";

// Helper function to set content type from media type
/**
 * setContentTypeFromMediaType function.
 *
 * @param {*} headers - Parameter description
 * @param {*} string> - Parameter description
 * @param {*} mediaType - Parameter description
 *
 * @returns {*} Return value description
 */
function setContentTypeFromMediaType(headers: Record<string, string>, mediaType: string): void {
  headers["Content-Type"] = mediaType;
}

// Helper function to set content type from blob
/**
 * setContentTypeFromBlob function.
 *
 * @param {*} headers - Parameter description
 * @param {*} string> - Parameter description
 * @param {*} body - Parameter description
 *
 * @returns {*} Return value description
 */
function setContentTypeFromBlob(headers: Record<string, string>, body: Blob): void {
  headers["Content-Type"] = body.type || "application/octet-stream";
}

// Helper function to set content type for string body
/**
 * setContentTypeForString function.
 *
 * @param {*} headers - Parameter description
 * @param {*} string> - Parameter description
 *
 * @returns {*} Return value description
 */
function setContentTypeForString(headers: Record<string, string>): void {
  headers["Content-Type"] = "text/plain";
}

// Helper function to set content type for JSON body
/**
 * setContentTypeForJSON function.
 *
 * @param {*} headers - Parameter description
 * @param {*} string> - Parameter description
 *
 * @returns {*} Return value description
 */
function setContentTypeForJSON(headers: Record<string, string>): void {
  headers["Content-Type"] = "application/json";
}

// Helper function to set content type from body type
/**
 * setContentTypeFromBodyType function.
 *
 * @param {*} headers - Parameter description
 * @param {*} string> - Parameter description
 * @param {*} body - Parameter description
 *
 * @returns {*} Return value description
 */
function setContentTypeFromBodyType(headers: Record<string, string>, body: any): void {
  if (isBlob(body)) {
    setContentTypeFromBlob(headers, body);
    return;
  }

  if (isString(body)) {
    setContentTypeForString(headers);
    return;
  }

  if (!isFormData(body)) {
    setContentTypeForJSON(headers);
  }
}

// Helper function to set content type header
/**
 * setContentTypeHeader function.
 *
 * @param {*} headers - Parameter description
 * @param {*} string> - Parameter description
 * @param {*} body - Parameter description
 * @param {*} mediaType? - Parameter description
 *
 * @returns {*} Return value description
 */
export function setContentTypeHeader(
  headers: Record<string, string>,
  body: any,
  mediaType?: string
): void {
  if (!body) {
    return;
  }

  if (mediaType) {
    setContentTypeFromMediaType(headers, mediaType);
    return;
  }

  setContentTypeFromBodyType(headers, body);
}
